import React from 'react';
import { Link } from 'react-router-dom';

class UserSettingsMenuItem extends React.Component {
  render() {
    const {
      href,
      to,
      text,
      alt,
      activeTab,
      setActiveTab,
      disabled
    } = this.props;

    return (
      <div style={styles.settingsLinkContainer}>
        {!href && !disabled && (
          <Link style={styles.linkWrapper} onClick={() => setActiveTab(alt)} to={to}>
            <p style={alt === activeTab ? styles.activeLinkText : styles.linkText}>{text}</p>
          </Link>
        )}
        {!!href && !disabled && (
          <a style={styles.linkWrapper} href={href}>
            <p style={styles.linkText}>{text}</p>
          </a>
        )}
        {disabled && (
          <p style={styles.disabledLinkText}>{text}</p>
        )}
      </div>
    );
  }
}

const styles = {
  activeLinkText: {
    opacity: .5,
  },
  disabledLinkText: {
    opacity: .5,
  },
  settingsLinkContainer: {
    paddingLeft: 16,
    paddingTop: 8,
  },
};

export default UserSettingsMenuItem;
